import React, { Component } from 'react';
import Config from './Config';
import Modal from './Modal';
//import { Scrollbars } from 'react-custom-scrollbars';
import './css/Reports.css';
import FX from './functions/functions';
class Reports extends Component {
  constructor(props) {
  super(props)
    this.state = {options:{}};
  
  }
  render() {
     return  <div className="Reports">Ex</div>
  }
    
    
    
    
    
  generateReport = report => {
      
      var request = {customer_id : this.props.root.state.customer_id, report: report };
      FX.load(this.props.root,'generateReport' , (res, i) => {
          
           console.log(res.tgt);
           console.log("https://api.vdepot.co.uk/downloads/" + res.tgt);
           this.setState( {dlLink : res.tgt });
          
          
      }, {method:'POST',data:request});
      
  }
  generateReportX = (report) => {
    var request = {};
       var xhr = new XMLHttpRequest();
       var method = 'POST';
       
       xhr.onreadystatechange = () => {
        var DONE = 4; // readyState 4 means the request is done.
        var OK = 200; // status 200 is a successful return.
        if (xhr.readyState === DONE) {
          this.props._root.setState({waiting: false});
          if (parseInt(xhr.status, 10) === OK) {
              var retx;
              try{
                retx = JSON.parse(xhr.responseText);
                console.log(retx);
                console.log("https://api.vdepot.co.uk/downloads/" + retx.tgt);
                //var win = window.open("https://api.vdepot.co.uk/downloads/" + retx.tgt,'_blank');
                //win.focus();
                //if(null===(win)){
                //  alert('You appear to be blocking pop-ups...\nPlease make sure that you have allowed pop-ups and try again')
                //}
                
                if(retx){
                  this.setState( {dlLink : retx.tgt });
                  document.getElementById('blocked').style.display = 'block';
                }
              }
              catch (e){
                console.log(e);
                console.log(xhr.responseText);
	              alert('Er 706. An error has occured');
              }
	          }
	          else {
	            alert('Er 706. An error has occured');
	          }
          } else if (xhr.status) {
          }
      };
      if(localStorage.token){
        //xhr.open(method, Funx.apiHost + '/generateReport');
        xhr.setRequestHeader("X-Token-Sec", localStorage.token);
        try{
          xhr.send(JSON.stringify(request));
        }
        catch(e){
          console.log(e);
        }
        this.props._root.setState({waiting: true, blockChange: false});
      }
	}
	clearDL = () => {
	  this.setState({dlLink : ''});
	}
    
      isAdmin = () => {
        var user = this.props.root.state.user;
        return parseInt(user.admin_level, 10);
      }
    render() {
        console.log(this.state.dlLink);
      var popper;
          if(this.state.dlLink){
            var tgt = "https://api.vdepot.co.uk/downloads/" + this.state.dlLink;
            popper = (<div id="blocked">
            <a href={tgt} target="_blank" onClick={this.clearDL}>Click here to download</a>
           </div>);
          }
          var notifies;
          if(this.isAdmin()){
            notifies = <li><a onClick={this.generateReport.bind(this,'notifies_report')}>Notifies</a></li>
          }
          return (<div className="Reports">
           <ul>
            <li onClick={this.generateReport.bind(this,'all_ps_stock_report')}><a>All Stock by Product Set</a></li>
            <li onClick={this.generateReport.bind(this,'items_sent_by_day')}><a>Items Dispatched by Day</a></li>
            <li onClick={this.generateReport.bind(this,'stock_report')}><a>Stock Report</a></li>
            {notifies}
           </ul>
           {popper}
          </div>);
     }
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
}

export default Reports;



// WEBPACK FOOTER //
// ./src/Reports.js